"use client";

import { styled } from "@mui/material/styles";
import { CAROUSEL_ARROW_STYLE } from "./styles";
import Image from "next/image";
import Box from "@mui/material/Box";
import { H6, Paragraph } from "src/lib/components/salify-next-layout/default/components/Typography";
import { Carousel } from "../../salify-next-layout/default/components/carousel";
import { toAssetImages } from "src/lib/utils";
import { Button, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import clsx from "clsx";

const StyledCard = styled(Button, {
  shouldForwardProp: (props) => props !== "index",
})(({ theme, index }) => {
  const bgColorByIndex = (idx) => {
    if (idx % 3 === 1) return { normal: theme.palette.info[50], hover: theme.palette.info[300] };
    if (idx % 3 === 2)
      return { normal: theme.palette.warning[150], hover: theme.palette.warning[300] };
    return { normal: theme.palette.error[50], hover: theme.palette.error[300] };
  };
  return {
    display: "flex",
    flexDirection: "row",
    borderRadius: 8,
    textAlign: "left",
    transition: "all 0.3s",
    padding: "0.5rem 1rem",
    alignItems: "center",
    ":hover": {
      backgroundColor: bgColorByIndex(index).hover,
    },
    backgroundColor: bgColorByIndex(index).normal,
  };
});
const ImgBox = styled("div")(({ imgSize = 80 }) => ({
  height: imgSize,
  width: imgSize,
  flex: "1 0 auto",
}));

// ===================================================
export const CategoryCard = ({ sx, href, imgUrl, title, available, index, imgSize = 80 }) => {
  return (
    <StyledCard href={href} sx={sx} index={index}>
      <ImgBox imgSize={imgSize}>
        <Image
          alt={title}
          width={imgSize}
          height={imgSize}
          src={imgUrl}
          style={{
            height: imgSize,
            width: imgSize,
            objectFit: "contain",
          }}
        />
      </ImgBox>
      <Box ml={1} display={"flex"} flexDirection={"column"} textAlign={"left"} flex="8 1 auto">
        <H6 fontSize={14} mt="8px" mb="5px">
          {title}
        </H6>
        <Paragraph color="grey.600">{available}</Paragraph>
      </Box>
    </StyledCard>
  );
};

const CategoryList = ({ categoryList }) => {
  const [isAfterInit, setIsAfterInit] = useState(false);
  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery("(max-width:767px)");

  const responsive = [
    {
      breakpoint: breakpoints.values.xl,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: breakpoints.values.lg,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: breakpoints.values.sm,
      settings: {
        slidesToShow: 2,
      },
    },
  ];
  const cls = clsx({
    "on-init": !isAfterInit,
  });

  const [slideToShow, setSlideToShow] = useState(1);

  useEffect(() => {
    if (!isMobile) {
      setSlideToShow(3);
    }
  }, [isMobile]);

  return (
    <div>
      <div className={cls}>
        {
          <Carousel
            slidesToShow={slideToShow}
            initialSlide={0}
            responsive={responsive}
            arrowStyles={CAROUSEL_ARROW_STYLE}
            onInit={() => {
              setIsAfterInit(true);
            }}
          >
            {categoryList.map((item, ind) => (
              <CategoryCard
                key={item.id}
                href={`/collection/${item.code ?? ""}`}
                index={ind}
                title={item.name}
                available={item.description}
                imgUrl={
                  item.imageUrl
                    ? toAssetImages(item.imageUrl)
                    : item.imageUrlIcon
                      ? toAssetImages(item.imageUrlIcon)
                      : item.imgUrl ||
                        "/assets/images/06f2ae32-86a2-45ea-bce3-09182a5b9b5d/t-thumb.jpeg"
                }
                imgSize={28}
                sx={{ height: "inherit" }}
              />
            ))}
          </Carousel>
        }
      </div>
    </div>
  );
};

export default CategoryList;
